import React, { FunctionComponent } from 'react';
import SimpleButton from '../../../../../common/components/presentation/simpleButton/SimpleButton';
import { IButtonProps } from '../ActionButtons';
import actionButtonsStyles from '../ActionButtonsStyles';
import { Typography, Box } from '@material-ui/core';
import Translation from '../../../../../common/components/translation/Translation';

type Props = IButtonProps & { disabled: boolean };

const Save: FunctionComponent<Props> = ({ onClick, disabled }) => {
  const styles = actionButtonsStyles();

  return (
    <Box className={styles.item}>
      <SimpleButton type="simple" dataTest="customise:summary:save" action={onClick} disabled={disabled}>
        <Typography variant="caption">
          <Translation id={'spc.customise.button.save'} />
        </Typography>
      </SimpleButton>
    </Box>
  );
};

export default Save;
